import I18n from 'app/i18n';
import LineInterface from 'app/interfaces/LineInterface';
import {lineGamer} from 'app/lines/line_helpers';

export const DEFAULT_HANDICAP = 'handicap_0';

const gamerTitle = (line: LineInterface, locale: string): string | null => {
    const gameInfo = lineGamer(line, 1);

    if (!gameInfo) {
        return null;
    }

    const localized = gameInfo.langs && gameInfo.langs[locale];

    if (localized) {
        return localized;
    }

    return gameInfo.game_name || null;
};

export const resolveGroupTitle = (
    lines: LineInterface[],
    siteLang?: string | null
): string => {
    const titledLines = lines.filter(line => !line.type_map);

    if (!titledLines.length) {
        return '';
    }

    const locale = siteLang || I18n.locale;
    const localizedLine = titledLines.find(line => {
        const gameInfo = lineGamer(line, 1);

        return Boolean(gameInfo?.langs && gameInfo.langs[locale]);
    });
    const title = gamerTitle(localizedLine || titledLines[0], locale);

    if (!title) {
        return I18n.t(DEFAULT_HANDICAP);
    }

    return title;
};
